import React from 'react'

import { LINK_TYPES } from '~/core/constants'

import GoogleSlideSvg from './icons/google-slide'
import GoogleSheetSvg from './icons/google-sheet'
import GoogleDocSvg from './icons/google-doc'
import PdfSvg from './icons/pdf'
import ImageSvg from './icons/image'
import LinkSvg from './icons/link'
import VideoSvg from './icons/video'
import getUnknownIcon from './icons/unknown'

export default {
  [LINK_TYPES.GOOGLE_DOC]: <GoogleDocSvg role='presentation' />,
  [LINK_TYPES.GOOGLE_SHEET]: <GoogleSheetSvg role='presentation' />,
  [LINK_TYPES.GOOGLE_SLIDE]: <GoogleSlideSvg role='presentation' />,
  [LINK_TYPES.PDF]: <PdfSvg role='presentation' />,
  [LINK_TYPES.IMAGE]: <ImageSvg role='presentation' />,
  [LINK_TYPES.LINK]: <LinkSvg role='presentation' />,
  [LINK_TYPES.VIDEO]: <VideoSvg role='presentation' />,
  [LINK_TYPES.UNKNOWN]: getUnknownIcon()
}
